import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import ErrorIcon from '../../assets/svgs/ErrorIcon';
import SuccessIcon from '../../assets/svgs/SuccessIcon';

import { SnackBarStyle } from './SnackBarStyle';

const SnackBar = ({ type, text }) => {
  const renderIcon = useMemo(() => {
    if (type === 'success') {
      return <SuccessIcon />;
    }

    if (type === 'error') {
      return <ErrorIcon />;
    }

    return null;
  }, [type]);

  return (
    <SnackBarStyle className={`${type}-type`}>
      {renderIcon ? <div className="snack-bar-icon">{renderIcon}</div> : null}
      <p className="snack-bar-text">{text}</p>
    </SnackBarStyle>
  );
};

SnackBar.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string.isRequired,
};

SnackBar.defaultProps = {
  type: 'error',
};

export default SnackBar;
